/** Embedding host values reported in the PageUsageEvent `host` dimension. */
export const PAGE_USAGE_HOST = {
  standalone: 'standalone',
  teams: 'teams',
} as const;
